import MembershipOpenInvoiceListResourcePagingResultModel from '../../generated/types/model/resource/MembershipOpenInvoiceListResourcePagingResultModel';

export default class MembershipOpenInvoiceListResourcePagingResultViewModel extends MembershipOpenInvoiceListResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
